<template>
	<div class="moduleAreaNavStyle">
		<el-dialog title="设置栏目样式" :modal=false :append-to-body=true :visible.sync="editDial.isStyleEdit" width="60%">
			<div class="g-cf add_nav_cons">
				<div v-if="itemMdata.tName=='moduleAreaNav'" class="columnLayoutEdit">
					<div class="btn_con">
						<h2>设置{{editDial.isStyleEdit}}</h2>
						<div class="styleMel clearfloat">
							<span>模块样式：</span>
							<ul>
								<li class="fl" v-for="(item,idx) in imgSrc" @click="curMapStyle(item,idx)">
									<img :src="item" />
								</li>
							</ul>
						</div>
						<div class="style clearfloat">
							<span>背景颜色：</span>
							<el-color-picker v-model="itemMdata.layoutOuterStyle.backgroundColor" size="medium"></el-color-picker>
						</div>
						<div class="style clearfloat">
							<span>内间距：</span>
							<input type="text" class="txt" v-model="itemMdata.layoutOuterStyle.padding" placeholder="如:'10% 10% 3% 3%'" />
						</div>
						<h2>按钮设置</h2>
						<div class="borderStyle">
							<span>背景颜色：</span>
							<el-color-picker v-model="itemMdata.layoutOuterStyleLi.backgroundColor" size="medium"></el-color-picker>
							<p class="ft_ck">
								<p>
									<span>是否显示边框：</span>
									<span>是</span>
									<input type="radio" name="showB" @click="showBY()" :checked="showBorder==1" />
									<span>否</span>
									<input type="radio" name="showB" @click="showBN()" :checked="showBorder==2" />
								</p>
								<el-form>
									<el-form-item label="边框样式：" style="{marginBottom:0;}">
										<el-select v-model="itemMdata.layoutOuterStyleLi.borderStyle" placeholder="请选择线">
											<el-option v-for="item in line" :key="item.value" :label="item.label" :value="item.value">
											</el-option>
										</el-select>
									</el-form-item>
								</el-form>
								<div class="style clearfloat">
									<span>外间距：</span>
									<input type="text" class="txt" v-model="itemMdata.layoutOuterStyleLi.margin" placeholder="如:'10% 10% 3% 3%'" />
								</div>
								<span>字体颜色：</span>
								<el-color-picker v-model="itemMdata.layoutOuterStyleLi.color" size="medium"></el-color-picker>
								<span>边框宽度：</span>
								<input type="text" class="txt" v-model="itemMdata.layoutOuterStyleLi.borderWidth" placeholder="如3px" />
								<span>边框颜色：</span>
								<el-color-picker v-model="itemMdata.layoutOuterStyleLi.borderColor" size="medium"></el-color-picker>
							</p>
						</div>
					</div>
				</div>
				<mButtonEdit v-if="itemMdata.tName=='msgSubmit'||itemMdata.tName=='siteForm'" :itemMdata="itemMdata.buttonEdit" :isLink="1"></mButtonEdit>
			</div>
			<span slot="footer" class="dialog-footer">
		    <!--el-button @click="addVisibleNav = false">取 消</el-button-->
		    <el-button type="primary" @click="addVisibleFun">保 存</el-button>
		  </span>
		</el-dialog>
	</div>
</template>
<script>
	import mImageEdit from '@/components/t2/m/mImageEdit.vue'
	import mButtonEdit from './mButtonEdit.vue'
	import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
	export default {
		name: 'moduleAreaNavStyle',
		components: {
			mImageEdit,
			mButtonEdit
		},
		props:["itemMdata","editDial"],
		created() {
			console.log("moduleAreaNav___Style");
		},
		methods: {
			showBY() {
				var ts = this;
				ts.itemMdata.layoutOuterStyleLi.borerColor = '#ccc';
				ts.itemMdata.layoutOuterStyleLi.borderStyle = 'solid';
				ts.itemMdata.layoutOuterStyleLi.borderWidth = '1px';
				ts.showBorder = 1;
			},
			addVisibleFun() {
				//debugger;
				this.editDial.isStyleEdit = false;
			},
			curMapStyle(item, idx) {
				let ts = this;
				ts.itemMdata.model = idx;
			},
			showBN() {
				var ts = this;
				ts.itemMdata.layoutOuterStyleLi.borerColor = '';
				ts.itemMdata.layoutOuterStyleLi.borderStyle = '';
				ts.itemMdata.layoutOuterStyleLi.borderWidth = '';
				ts.showBorder = 2;
			}
		},
		computed: {
			...mapGetters(["router", 'itemCon'])
		},
		data() {
			return {
				title: "栏目导航",
				dialogImageUrl: '',
				dialogVisible: false,
				type_hid: true,
				imgSrc: ['../../../static/image/productNav1.jpg', '../../../static/image/productNav2.jpg'],
				showBorder: 0,
				line: [{
					value: 'solid',
					label: '实线'
				}, {
					value: 'dashed',
					label: '虚线'
				}, {
					value: 'dotted',
					label: '点线'
				}, {
					value: 'double',
					label: '双线'
				}],
				type_hid2: false
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
	.fl {
		display: inline-block;
	}
	
	.moduleAreaNavStyle {
		z-index: 1000;
		height: 100%;
		box-sizing: border-box;
	}
	
	.txt {
		border: 1px solid #ccc;
		height: 30px;
		padding-left: 5px;
		line-height: 30px;
	}
	
	.add_nav_cons {
		box-sizing: border-box;
		height: 334px;
		overflow: auto;
		.top {
			clear: both;
			overflow: hidden;
			padding-left: 10px;
			background: #F5F5F5;
			border-bottom: 1px solid #CCCCCC;
			p {
				float: left;
				padding: 0 15px;
				line-height: 35px;
				border: 1px solid #E3E3E3;
			}
			.active {
				background: #FFFFFF;
				color: #409EFF;
			}
		}
		.one {
			box-sizing: border-box;
			padding: 20px;
			h3 {
				font-weight: normal;
			}
			.marginL {
				margin-left: 40px;
				height: 120px;
				background: #fff;
			}
			.navStyle {
				position: relative;
				height: 120px;
				i {
					display: inline-block;
					width: 40px;
					height: 40px;
					position: absolute;
					background: #409EFF;
					text-align: center;
					line-height: 40px;
					border-radius: 100%;
					color: #fff;
					font-size: 20px;
					top: 50%;
					transform: translate(-50%, -50%);
				}
				.pre {
					left: 14px;
				}
				.next {
					right: -1px;
				}
				ul {
					overflow: hidden;
					width: 1000px;
					height: 120px;
					position: absolute;
					top: 0;
					left: 40px;
					li {
						float: left;
						margin: 10px 10px;
						img {
							border: 1px solid #ccc;
						}
						.default {
							width: 166px;
							height: 106px;
							border: 1px solid #ccc;
							text-align: center;
							line-height: 108px;
						}
						.actived {
							border: 1px solid #409EFF;
						}
					}
				}
			}
			.name {
				span {
					width: 70px;
					text-align: right;
				}
				input {
					border: 1px solid #E3E3E3;
					padding-left: 10px;
					line-height: 30px;
				}
			}
			.bg {
				margin-top: 10px;
				clear: both;
				overflow: hidden;
				span {
					text-align: right;
					float: left;
				}
				p {
					float: left;
					margin-left: 10px;
				}
				.bg_hid {
					clear: both;
					overflow: hidden;
					margin-left: 100px;
					p {
						float: none;
						margin-top: 10px;
						line-height: 30px;
						button {
							border: 1px solid #E3E3E3;
							text-align: center;
							padding: 2px 10px;
						}
						input {
							border: 1px solid #E3E3E3;
							text-align: center;
							width: 60px;
							line-height: 30px;
						}
					}
				}
			}
			.effect {
				margin-top: 10px;
				clear: both;
				overflow: hidden;
				span {
					width: 70px;
					text-align: right;
					float: left;
				}
				p {
					float: left;
					margin-left: 10px;
				}
				.effect_hid {
					clear: both;
					overflow: hidden;
					.style {
						clear: both;
						overflow: hidden;
						margin-top: 10px;
						span {
							float: left;
						}
						ul {
							float: left;
							width: 88%;
							li {
								float: left;
								width: 23%;
								margin-left: 5px;
							}
							div {
								border: 1px solid #E3E3E3;
								width: 108px;
								height: 43px;
								background: url(../../../../static/image/mbg01.png) no-repeat;
							}
							p {
								text-align: center;
								float: none;
								font-size: 12px;
								margin-top: 5px;
								margin-left: 0;
								color: #666666;
							}
							.style_one {
								background-position: -865px -1264px;
							}
							.style_two {
								background-position: -865px -1324px;
							}
							.style_three {
								background-position: -865px -1204px;
							}
							.style_four {
								background-position: -865px -1384px;
							}
						}
					}
					.page {
						margin-top: 10px;
						line-height: 30px;
						input {
							border: 1px solid #E3E3E3;
							text-align: center;
							width: 60px;
							margin-left: 5px;
							line-height: 30px;
						}
					}
				}
			}
		}
		.two {
			box-sizing: border-box;
			padding: 20px;
			.cont {
				.el-form-item {
					margin-bottom: 10px;
				}
				.el-form-item__content {
					line-height: 0;
				}
			}
			.border {
				clear: both;
				overflow: hidden;
				span {
					width: 70px;
					text-align: right;
					float: left;
				}
				p {
					float: left;
					margin-left: 10px;
				}
				.border_hid {
					clear: both;
					overflow: hidden;
					margin-left: 50px;
					.border1 {
						margin-top: 10px;
						input {
							border: 1px solid #E3E3E3;
							text-align: center;
							width: 60px;
							margin-right: 4px;
							line-height: 30px;
						}
					}
					.border2 {
						margin-top: 10px;
						line-height: 30px;
					}
					.border3 {
						margin-top: 10px;
						clear: both;
						overflow: hidden;
						.color_hid {
							float: left;
							margin-left: 10px;
						}
					}
				}
			}
			.margin {
				clear: both;
				overflow: hidden;
				margin-top: 10px;
				span {
					width: 70px;
					text-align: right;
					float: left;
				}
				p {
					float: left;
					margin-left: 10px;
				}
				.margin_hid {
					clear: both;
					overflow: hidden;
					margin-left: 60px;
					p {
						margin-top: 10px;
						margin-left: 20px;
						span {
							width: auto;
						}
						input {
							border: 1px solid #E3E3E3;
							width: 60px;
							margin-right: 4px;
							text-align: center;
						}
					}
				}
			}
			.width {
				clear: both;
				overflow: hidden;
				margin-top: 10px;
				line-height: 30px;
				span {
					float: left;
					width: 70px;
					text-align: right;
				}
				p {
					float: left;
					margin-left: 10px;
				}
				.width_hid {
					float: left;
					margin-left: 10px;
					input {
						border: 1px solid #E3E3E3;
						text-align: center;
						width: 70px;
						line-height: 30px;
					}
				}
			}
			.bg {
				margin-top: 10px;
				span {
					float: left;
					width: 70px;
					text-align: right;
				}
				p {
					float: left;
					margin-left: 10px;
				}
				.bg_hid {
					clear: both;
					overflow: hidden;
					margin-left: 50px;
					p {
						float: none;
						margin-top: 10px;
						line-height: 30px;
						button {
							border: 1px solid #E3E3E3;
							text-align: center;
							padding: 2px 5px;
							color: #666666;
						}
						input {
							border: 1px solid #E3E3E3;
							text-align: center;
							width: 60px;
						}
					}
				}
			}
			.carousel {
				clear: both;
				overflow: hidden;
				margin-top: 10px;
				clear: both;
				overflow: hidden;
				span {
					float: left;
					width: 70px;
					text-align: right;
				}
				p {
					float: left;
					margin-left: 10px;
				}
				.carousel_hid {
					clear: both;
					overflow: hidden;
					margin-left: 70px;
					p {
						clear: both;
						overflow: hidden;
						float: none;
						margin-top: 10px;
						span {
							width: auto;
							margin-left: 5px;
						}
						input {
							float: left;
							margin-right: 4px;
							border: 1px solid #E3E3E3;
							text-align: center;
							width: 60px;
						}
					}
				}
			}
		}
	}
	
	.on_con img {
		width: 100px;
		height: 100px;
	}
	
	.on_con {
		width: 120px;
		margin-left: 80px;
		margin-top: 20px;
		position: relative;
		height: 120px;
	}
	
	.on_con .close {
		position: absolute;
		right: 0;
		top: 0;
		color: #FFFFFF;
		background: red;
		text-align: center !important;
		width: 15px !important;
		height: 17px;
		cursor: pointer;
		line-height: 17px;
		border-radius: 100%;
		text-align: center;
		opacity: 0.7;
		font-size: 11px;
		display: none;
	}
	
	.on_con:hover .close {
		display: block;
	}
	
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: #f1f1f1;
	}
	
	::-webkit-scrollbar-thumb {
		background-color: #b2b2b2;
		width: 16px;
		-webkit-border-radius: 16px;
		-moz-border-radius: 16px;
		border-radius: 16px;
	}
</style>


// WEBPACK FOOTER //
// src/components/t2/m/moduleAreaNavStyle.vue